import { render, staticRenderFns } from "./GoogleBusinessProfile.vue?vue&type=template&id=cd4713dc&scoped=true"
import script from "./GoogleBusinessProfile.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessProfile.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessProfile.vue?vue&type=style&index=0&id=cd4713dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4713dc",
  null
  
)

export default component.exports